// extracted by mini-css-extract-plugin
export default {"start_soon":"startsoon_start_soon__vQj20"};